module.exports = __webpack_public_path__ + "img/EN_US_noveltyBadge.18f5e53e.svg";